import { ValidationSummary } from '../_models/validation-summary.model';

export const addValidation = (acc: ValidationSummary[], validation: ValidationSummary) => {
  const { errors, children } = validation;
  if (errors || (children && children.length)) {
    acc = [...acc, validation];
  }
  return acc;
};

export const getErrorSummaryCount = (errors: ValidationSummary[]) => {
  const errorCount = errors.reduce((acc, validation) => {
    const { errors: err, children } = validation;
    if (children && children.length) {
      acc += getErrorSummaryCount(children);
    }

    if (err) {
      acc++;
    }

    return acc;
  }, 0);

  return errorCount;
};
